import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { LoggedInGuard } from "../auth/auth.guards";
import { FlowTestsListComponent } from "./flow-tests-list/flow-tests-list.component";
import { FlowTestCreateComponent } from "./flow-test-create/flow-test-create.component";
import { FlowTestDetailComponent } from "./flow-test-detail/flow-test-detail.component";

const routes: Routes = [
  {
    path: "",
    canActivate: [LoggedInGuard],
    runGuardsAndResolvers: "always",
    data: { sidebar: "flow-tests", title: "Flow Tests" },
    children: [
      { path: "", redirectTo: "list", pathMatch: "full" },
      {
        path: "list",
        component: FlowTestsListComponent,
        data: { sidebar: "flow-tests", title: "Flow Tests" },
      },
      {
        path: "create",
        component: FlowTestCreateComponent,
        data: { sidebar: "flow-tests", title: "New Flow Test" },
      },
      {
        path: ":id",
        component: FlowTestDetailComponent,
        data: { sidebar: "flow-tests", title: "Flow Test Detail" },
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class FlowTestsRoutingModule {}

const flowTestsModuleLazyLoadRoutes: Routes = [
  {
    path: "flow-tests",
    loadChildren: () =>
      import("./flow-tests.module").then((m) => m.FlowTestsModule),
  },
];

export { flowTestsModuleLazyLoadRoutes };
